const namespace = '[ENTITY_DRIVERS]';

export const FETCH_DRIVERS = `${namespace} FETCH_DRIVERS`;
export const SET_DRIVERS = `${namespace} SET_DRIVERS`;
